<div mat-dialog-content>
  <p>{{ data.prompt }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button
    mat-button
    color="warn"
    [mat-dialog-close]="data.prompt"
    cdkFocusInitial
  >
    Confirm
  </button>
</div>
